<div class="lum-c-order-fulfillment-grid-actions">
  <button
    mat-button
    [matMenuTriggerFor]="menu"
    class="lum-button lum-button--secondary"
  >
    Actions <i class="flaticon-more ml-2"></i>
  </button>

  <mat-menu #menu="matMenu" [overlapTrigger]="false" class="lum-mat-menu">
    <button mat-menu-item (click)="createFulfillmentOrder()">
      Create Fulfillment Order
    </button>
    <ng-container *ngIf="ftPushUnPushToFulfilllmentChannel">
      <button
        mat-menu-item
        (click)="onPushToFulfillmentChannel()"
        *ngIf="selectedRowIds?.length > 0"
      >
        Push to Fulfillment Channel ({{ selectedRowCount }})
      </button>
      <button
        mat-menu-item
        (click)="onRemoveFromFulfillmentChannel()"
        *ngIf="selectedRowIds?.length > 0"
      >
        Unpush from WMS ({{ selectedRowCount }})
      </button>
    </ng-container>
    <ng-container *ngIf="'red_DV-3395_channel_types' | featureFlag">
      <button
        mat-menu-item
        (click)="onBatchCreateInvoices()"
        *ngIf="selectedRowIds?.length > 0"
      >
        Create Invoices ({{ selectedRowCount }})
      </button>
    </ng-container>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onClearGridState()">Reset to Default</button>
  </mat-menu>
</div>
